import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=5e3f7bb8"
import script from "./ReviewDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports